<div *ngIf="title" class="mat-dialog-header">
    <div mat-dialog-title>{{title}}</div>
    <div *ngIf="subtitle" class="mat-dialog-overline">{{subtitle}}</div>
</div>
<div mat-dialog-content [class.no-top-padding]="title">
  <div class="mat-subtitle-2">{{content}}</div>
</div>
<div mat-dialog-actions>
  <button *ngIf="!hideCancel" mat-button class="mat-button-text-sm" (click)="cancelClick()">{{cancel}}</button>
  <button mat-flat-button class="mat-button-primary-sm" (click)="primaryClick()">{{approve}}</button>
</div>